import React from 'react';

import addIcon from '@/assets/icons/member-add.svg';

interface MembersSectionHeaderProps {
  memberCount: number;
  onInviteClick?: () => void;
}

const MembersSectionHeader: React.FC<MembersSectionHeaderProps> = ({ memberCount, onInviteClick }) => {
  return (
    <header className="flex items-center justify-between border-b pb-3 md:border-b-0 md:pb-0">
      <div>
        <h3 className="font-bold text-gray">Members</h3>
        <p className="text-secondary text-sm">
          {memberCount} {memberCount === 1 ? 'Person' : 'Persons'}
        </p>
      </div>

      {onInviteClick && (
        <button
          type="button"
          className="text-primary font-semibold text-sm flex gap-1.5 items-center hover:underline py-1"
          onClick={onInviteClick}
        >
          <img src={addIcon} alt="add-icon" />
          <span>Invite</span>
        </button>
      )}
    </header>
  );
};

export default MembersSectionHeader;
